import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { AttributeList } from '../../attribute-list';
import { DisplayText } from '../../display-text';
import { Modal } from '../../modal/modal';
const b = bemClassBuilder('v-attribute-legend-modal');
export const AttributeLegendModal = observer(props => {
    const { show, heading, attributes, onClose, helpText, iconCdnOptions } = props;
    return (_jsxs(Modal, Object.assign({ heading: heading, show: show, onClose: onClose, className: b.block() }, { children: [_jsx(AttributeList, { attributes: attributes, showDetails: true, iconCdnOptions: iconCdnOptions }), helpText && _jsx(DisplayText, { className: b.element('help-text'), label: helpText })] })));
});
AttributeLegendModal.displayName = 'AttributeLegendModal';
